<div class="booking-step">
  <lx-enrolment-form (submitForm)="submitLead()"></lx-enrolment-form>
  <div class="booking-step__footer" @slideDepositFooterAnimation *ngIf="visibleDepositFooter$ | async">
    <div class="booking-step__footer__quote-breakdown" (click)="showQuoteBreakdown()">
      <div class="booking-step__footer__quote-breakdown__icon">
        <i class="pi pi-chevron-up"></i>
      </div>
      <div class="booking-step__footer__quote-breakdown__link" i18n data-qa="bookingStep_quoteBreakdown_link">Details</div>
    </div>
    <div class="booking-step__footer__deposit" *ngIf="payableData$ | async as payableData">
      <div class="booking-step__footer__deposit__message" i18n>Deposit due today</div>
      <div class="booking-step__footer__deposit__price">
        <span class="booking-step__footer__deposit__price__amount">
          {{
            payableData.amounts
              | lxPrice
                : {
                    currency: currency$ | async,
                    minDecimalPlaces: 0,
                    showCurrency: false
                  }
          }}
        </span>
        <span class="booking-step__footer__deposit__price__currency">
          {{ currency$ | async }}
        </span>
      </div>
    </div>
  </div>
</div>
